module.exports = __webpack_public_path__ + "static/contact_hero-470534ed7cf4003726ab84850f5e7a76.png";